/* Alawooder Art House: native storefront enhancement and product-form feedback. */
(function () {
  'use strict';

  var theme = window.AWTheme = window.AWTheme || {};
  if (theme.initialized) return;
  theme.initialized = true;

  var config = window.Alawooder || {};
  var routes = config.routes || {};
  var pendingForms = new WeakSet();
  var announcementTimer;
  var cartQueue = Promise.resolve();

  theme.formatMoney = function (cents) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    var currency = config.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var locale = document.documentElement.lang || navigator.language || 'en-US';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: amount % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(amount / 100);
    } catch (error) {
      return (amount / 100).toFixed(2) + ' ' + currency;
    }
  };

  theme.announce = function (message) {
    var region = document.getElementById('ah-announcement');
    if (!region) return;
    window.clearTimeout(announcementTimer);
    region.textContent = '';
    announcementTimer = window.setTimeout(function () {
      region.textContent = String(message || '');
    }, 30);
  };

  function ajaxRoute(route, fallback) {
    var url = new URL(route || fallback, window.location.origin);
    url.pathname = url.pathname.replace(/\.(?:js|json)$/i, '').replace(/\/$/, '') + '.js';
    return url.toString();
  }

  function rootPath(path) {
    return (routes.root || '/').replace(/\/?$/, '/') + path;
  }

  function formStatus(form, message, isError, showBag) {
    var section = form.closest('[data-aw-product]') || form;
    var regions = section.querySelectorAll('[data-aw-form-status]');
    regions.forEach(function (region) {
      region.textContent = message;
      region.hidden = false;
      region.dataset.state = isError ? 'error' : 'success';
      region.setAttribute('role', isError ? 'alert' : 'status');
      region.setAttribute('aria-live', isError ? 'assertive' : 'polite');
      if (showBag) {
        region.appendChild(document.createTextNode(' '));
        var link = document.createElement('a');
        var bagUrl = new URL(routes.cart || rootPath('cart'), window.location.origin);
        bagUrl.pathname = bagUrl.pathname.replace(/\.(?:js|json)$/i, '');
        link.href = bagUrl.toString();
        link.className = 'ah-link';
        link.setAttribute('data-aw-cart-open', '');
        link.textContent = 'View bag';
        region.appendChild(link);
      }
    });
    theme.announce(message);
  }

  function errorMessage(result, fallback) {
    if (!result) return fallback;
    if (typeof result === 'string') return result;
    if (typeof result.description === 'string') return result.description;
    if (result.errors) {
      if (typeof result.errors === 'string') return result.errors;
      var errors = Array.isArray(result.errors) ? result.errors : Object.values(result.errors);
      var messages = errors.map(function (error) {
        return Array.isArray(error) ? error.join(', ') : String(error);
      }).filter(Boolean);
      if (messages.length) return messages.join(' ');
    }
    return typeof result.message === 'string' ? result.message : fallback;
  }

  function associatedButtons(form) {
    return Array.from(document.querySelectorAll('[data-aw-add]')).filter(function (button) {
      return button.form === form || (!button.form && form.contains(button));
    });
  }

  function updateCount(cart) {
    if (!cart || !Number.isFinite(Number(cart.item_count))) return;
    var count = Number(cart.item_count);
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = String(count);
      var bag = node.closest('.ah-bag');
      if (bag) bag.setAttribute('aria-label', (bag.dataset.awBagLabel || 'Bag') + ', ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  async function readCart() {
    var response = await window.fetch(ajaxRoute(routes.cart, rootPath('cart')), {
      method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh the bag.');
    return response.json();
  }

  theme.cart = {
    read: readCart,
    updateCount: updateCount,
    pending: 0,
    enqueue: function (operation) {
      theme.cart.pending += 1;
      document.dispatchEvent(new CustomEvent('aw:cart-queue', { detail: { pending: theme.cart.pending } }));
      var next = cartQueue.then(operation, operation);
      cartQueue = next.catch(function () {});
      return next.finally(function () {
        theme.cart.pending -= 1;
        document.dispatchEvent(new CustomEvent('aw:cart-queue', { detail: { pending: theme.cart.pending } }));
      });
    }
  };

  async function addToCart(form, trigger) {
    if (pendingForms.has(form)) return;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    var formData = new FormData(form);
    var variantId = String(formData.get('id') || '').trim();
    var quantity = Number(formData.get('quantity') || 1);
    if (!/^\d+$/.test(variantId)) {
      formStatus(form, config.strings && config.strings.unavailable || 'Please choose an available option.', true, false);
      return;
    }
    if (!Number.isInteger(quantity) || quantity < 1) {
      formStatus(form, 'Please enter a quantity of 1 or more.', true, false);
      return;
    }

    var buttons = associatedButtons(form);
    if (buttons.length && buttons.every(function (button) { return button.disabled; })) return;
    var previousButtons = buttons.map(function (button) {
      return { element: button, disabled: button.disabled, busy: button.getAttribute('aria-busy') };
    });
    pendingForms.add(form);
    form.dataset.awBusy = 'true';
    buttons.forEach(function (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });
    form.dispatchEvent(new CustomEvent('aw:cart-busy', { bubbles: true, detail: { busy: true } }));
    formStatus(form, 'Adding to your bag…', false, false);

    try {
      await theme.cart.enqueue(async function () {
        try {
          var response = await window.fetch(ajaxRoute(routes.cartAdd, rootPath('cart/add')), {
            method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: formData
          });
          var result;
          try {
            result = await response.json();
          } catch (parseError) {
            throw new Error(response.ok ? 'We could not confirm the bag update. Please check your bag before trying again.' : 'We could not add this item. Please try again.');
          }
          if (!result || typeof result !== 'object') {
            throw new Error('We could not confirm the bag update. Please check your bag before trying again.');
          }
          if (!response.ok || result.status >= 400 || result.errors) {
            throw new Error(errorMessage(result, 'We could not add this item. Please try again.'));
          }

          var cart = null;
          try {
            cart = await readCart();
            updateCount(cart);
          } catch (cartError) {
            // A completed add stays successful if the separate count refresh is unavailable.
          }
          formStatus(form, 'Added to your bag.', false, true);
          form.dispatchEvent(new CustomEvent('aw:cart-updated', {
            bubbles: true, detail: { cart: cart, item: result, form: form, trigger: trigger, source: 'product-form' }
          }));
        } catch (error) {
          var message = error instanceof TypeError ? 'We could not confirm the bag update. Please check your bag before trying again.' : error.message;
          var actualCart = null;
          // Shopify can change the cart even when an add returns an inventory error.
          // Reconcile once; never replay an uncertain purchase request.
          try { actualCart = await readCart(); updateCount(actualCart); } catch (refreshError) {}
          message = message || 'We could not add this item. Please check your bag.';
          formStatus(form, message, true, false);
          form.dispatchEvent(new CustomEvent('aw:cart-error', {
            bubbles: true, detail: { cart: actualCart, error: message, form: form, trigger: trigger, source: 'product-form' }
          }));
        }
      });
    } finally {
      pendingForms.delete(form);
      delete form.dataset.awBusy;
      previousButtons.forEach(function (state) {
        var button = state.element;
        if (button.dataset.awAvailable === 'false') button.disabled = true;
        else if (button.dataset.awAvailable === 'true') button.disabled = false;
        else button.disabled = state.disabled;
        if (state.busy === null) button.removeAttribute('aria-busy');
        else button.setAttribute('aria-busy', state.busy);
      });
      form.dispatchEvent(new CustomEvent('aw:cart-busy', { bubbles: true, detail: { busy: false } }));
    }
  }

  if (typeof window.fetch === 'function' && typeof FormData === 'function') {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-aw-product-form]')) return;
      event.preventDefault();
      if (event.submitter && event.submitter.disabled) return;
      addToCart(form, event.submitter);
    });
  }

  function reservePurchaseBarSpace() {
    var bar = document.querySelector('[data-aw-fixed-buy]');
    if (!bar) return;
    var updateSpace = function () {
      document.documentElement.style.setProperty('--aw-purchase-bar-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    };
    updateSpace();
    if (window.ResizeObserver) new ResizeObserver(updateSpace).observe(bar);
    else window.addEventListener('resize', updateSpace, { passive: true });
  }
  reservePurchaseBarSpace();
}());
